module.exports = __webpack_public_path__ + "img/reloading-gif.6811c8cf.svg";